// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  conversationId: __t.u64().primaryKey().name("conversation_id"),
  conversationType: __t.string().name("conversation_type"),
  name: __t.option(__t.string()),
  description: __t.option(__t.string()),
  avatarUrl: __t.option(__t.string()).name("avatar_url"),
  createdBy: __t.identity().name("created_by"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
  isArchived: __t.bool().name("is_archived"),
});
